import axios from 'axios'

export class Aluno {
  static async alunoVacinacao($info) {
    return axios.get('/alunos/vacinacao/check', {params: $info});
  }
}
